"use client";

import { useEffect, useRef, useState } from "react";
import Swiper, { SwiperSlide } from "@/components/ui/swiper";
import { default as SwiperType } from "swiper";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { DirectusImage } from "@/components/DirectusImage";
import { cn } from "@/lib/utils";
import RichText from "../../Richtext";

import "./index.css";
import useSWR from "swr";

function PdfPreview(props: { file: string }) {
  const { data } = useSWR<{
    data: {
      id: string;
      filename_download: string;
      title: string;
      type: string;
    };
  }>(
    () =>
      props.file
        ? `${process.env.NEXT_PUBLIC_API_HOST}/files/${props.file}`
        : null,
    async (url: string) => {
      return fetch(url).then((res) => res.json());
    }
  );

  return (
    <a
      target="_blank"
      href={`${process.env.NEXT_PUBLIC_DIRECTUS_ASSETS}/${data?.data?.id}/${data?.data?.filename_download}`}
      className="flex flex-shrink-0 items-center space-x-2 text-base text-[#4DB08D]">
      <span>{data?.data?.title}</span>
      <span className="font-medium">PDF</span>
    </a>
  );
}

function ScrollArea(props: { children: React.ReactNode }) {
  // const scrollRef = useRef<HTMLDivElement>(null);

  // const [isScroll, setIsScroll] = useState(false);

  // useEffect(() => {
  //   const listener = () => {
  //     setTimeout(() => {
  //       if (scrollRef.current) {
  //         const height = scrollRef.current.clientHeight;

  //         setIsScroll(height > 360);
  //       }
  //     }, 0);
  //   };
  //   listener();
  //   window.addEventListener("resize", listener);
  //   return () => {
  //     window.removeEventListener("resize", listener);
  //   };
  // }, [scrollRef]);

  return (
    <div>
      <div className="app-scroll max-h-[360px] flex-1 overflow-y-auto pr-4 xl:pr-6">
        <div>{props.children}</div>
      </div>
    </div>
  );
}

export default function QualityOverviewClient(props: {
  content: {
    title?: string;
    description?: string;
    image?: string;
    file?: string;
  }[];
}) {
  const [isMobile, setIsMobile] = useState<boolean>();
  const [categorySwiper, setCategorySwiper] = useState<SwiperType>();

  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const listener = () => {
      setIsMobile(window.matchMedia("(max-width: 768px)").matches);
    };
    listener();
    window.addEventListener("resize", listener);
    return () => {
      window.removeEventListener("resize", listener);
    };
  }, []);

  return (
    <div className="w-full max-md:-ml-6 max-md:w-[100vw] max-md:bg-white max-md:px-6">
      {isMobile && (
        <Accordion
          type="single"
          collapsible
          className="mb-14 mt-4 flex flex-col gap-y-2">
          {props.content?.map((el, index) => (
            <AccordionItem
              className="border-none"
              key={index}
              value={`overview_${index}`}>
              <AccordionTrigger className="flex items-center justify-between rounded-lg bg-zinc-50 p-4 text-base">
                {el.title}
              </AccordionTrigger>
              <AccordionContent className="bg-zinc-50 px-3 pb-5 pt-1">
                <div className="relative h-[160px] w-full overflow-hidden rounded-md">
                  <DirectusImage
                    id={el.image || ""}
                    alt={el.title || ""}
                    fill
                    className="object-cover object-center"
                  />
                </div>

                <RichText
                  data={{
                    content: el.description,
                  }}
                />

                {el.file && <PdfPreview file={el.file} />}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      )}
      {!isMobile && (
        <>
          <div className="relative w-full px-10 xl:px-24">
            <div className="mt-12 flex w-full items-center justify-center gap-x-[70px] !pb-1 overflow-x-auto">
              {props.content?.map((el, index) => (
                <div
                  key={index}
                  className={cn(
                    "quality-overview-tab !w-auto py-3 text-lg text-[#383838] lg:text-xl whitespace-nowrap",
                    {
                      "quality-overview-tab-active": index === current,
                    }
                  )}
                  onClick={() => {
                    categorySwiper?.slideTo(index);
                  }}>
                  {el.title}
                </div>
              ))}
            </div>
          </div>
          <Swiper
            className="mt-6 w-full lg:mt-8"
            allowTouchMove={false}
            speed={0}
            navigation={{
              prevEl: ".category-prev",
              nextEl: ".category-next",
              lockClass: "category-button-lock",
              hiddenClass: "category-button-hidden",
              disabledClass: "category-button-disabled",
            }}
            spaceBetween={10}
            onSwiper={setCategorySwiper}
            onSlideChange={(swiper) => {
              setCurrent(swiper.activeIndex);
            }}>
            {props.content?.map((el, index) => (
              <SwiperSlide key={index}>
                <div className="flex h-[500px] overflow-hidden rounded-3xl bg-white xl:h-[545px]">
                  <div className="flex flex-1 flex-col justify-between py-10 pb-10 pl-6 pr-4 lg:pl-10 xl:pl-[6.25rem] xl:pr-8">
                    <div className="flex flex-1 flex-col pb-5">
                      <h3 className="mb-2 flex-shrink-0 text-lg font-bold lg:text-xl xl:mb-6">
                        {el.title}
                      </h3>

                      <ScrollArea>
                        <RichText
                          data={{
                            content: el.description,
                          }}
                        />
                      </ScrollArea>
                    </div>

                    {el.file && <PdfPreview file={el.file} />}
                  </div>

                  <div className="relative h-full w-1/2 flex-shrink-0 xl:w-[664px]">
                    {el.image && (
                      <DirectusImage
                        className="object-cover object-center"
                        id={el.image}
                        alt={el.title || ""}
                        fill
                      />
                    )}
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </>
      )}
    </div>
  );
}
